export const makeSlug = (str) => {
  str = str.toLowerCase();
  str = str.replace(/[^a-z0-9]+/g, "-");
  str = str.replace(/^-+|-+$/g, "");
  return str;
};

export const formatAmount = (num = 0) => {
  // console.log(num)
  return `₹ ${(num ?? 0)
    ?.toFixed(2)
    ?.toString()
    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};

export const formatListAmount = (num) => {
  return `${num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};
export const roundOffAmount = (num) => {
  return (num % 1).toFixed(2);
};
export const formatBookingAmount = (num) => {
  return `₹${num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};
// export const formatAddress = (addressLine1, addressLine2,  city, state, zip5) => {
//   let formattedAddress = ''
//   address2 ? formattedAddress = `${addressLine1} ${addressLine2}, ${city}, ${state} ${zip5}` : formattedAddress = `${addressLine1}, ${city}, ${state} ${zip5}`
//   return formattedAddress
// }
export const roundedToFixed = (input, digits) => {
  let rounded = Math.pow(10, digits);
  if (input > 0)
    return parseFloat((Math.round(input * rounded) / rounded).toFixed(digits));
};

export const roundedAmtToFixed = (input, digits) => {
  //customInvoice part
  let rounded = Math.pow(10, digits);
  if (input >= 0)
    return parseFloat((Math.round(input * rounded) / rounded).toFixed(digits));
};

export function findDiffDays(obj) {
  const date1 = new Date(obj.checkInDate);
  const date2 = new Date(obj.checkOutDate);
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}

export function removeDuplicatesByKey(array, key) {
  const uniqueObjects = [];
  const trackingObject = {};

  for (let i = array.length - 1; i >= 0; i--) {
    const obj = array[i];
    const identifier = obj[key];

    if (!trackingObject[identifier]) {
      trackingObject[identifier] = true;
      uniqueObjects.unshift(obj);
    }
  }

  return uniqueObjects;
}

export function removeObjectsByValue(array, value) {
  return array.filter((obj) => obj?._id?.name !== value);
}

export const statusDisabled = (value) => {
  if (value === 5 || value === 6) {
    return true;
  } else {
    return false;
  }
};

export function getFirstDateOfMonth(date) {
  if (!date || date === " Invalid Date") {
    return true;
  } else {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDate = new Date(year, month, 2);

    const formattedDate = firstDate.toISOString().split("T")[0];
    return formattedDate;
  }
}

export const colorBookingStatus = (status) => {
  switch (status) {
    // case 7:
    //   return {
    //     bg: "bg-yellow-50 dark:bg-yellow-600/10",
    //     text: "text-yellow-600 dark:text-yellow-100",
    //     dot: "bg-yellow-600",
    //     border: "border-2 border-yellow-200 dark:border-yellow-700",
    //   };
    case 2:
      return {
        bg: "bg-green-50 dark:bg-green-600/10",
        text: "text-green-600 dark:text-green-100",
        dot: "bg-green-600",
        border: "border-2 border-green-200 dark:border-green-700",
      };

    case 3:
      return {
        bg: "bg-orange-50 dark:bg-orange-600/10",
        text: "text-orange-500",
        dot: "bg-orange-600",
        border: "border-2 border-orange-200 dark:border-orange-700",
      };

    // case 4:
    //   return {
    //     bg: "bg-slate-50 dark:bg-slate-600/10",
    //     text: "text-slate-600 dark:text-slate-100",
    //     dot: "bg-slate-600",
    //     border: "border-2 border-slate-200 dark:border-slate-700",
    //   };
    // case 5:
    //   return {
    //     bg: "bg-slate-50 dark:bg-slate-600/10",
    //     text: "text-slate-600 dark:text-slate-100",
    //     dot: "bg-slate-600",
    //     border: "border-2 border-slate-200 dark:border-slate-700",
    //   };

    // case 6:
    //   return {
    //     bg: "bg-slate-50 dark:bg-slate-600/10",
    //     text: "text-slate-600 dark:text-slate-100",
    //     dot: "bg-slate-600",
    //     border: "border-2 border-slate-200 dark:border-slate-700",
    //   };

    default:
      return {
        // bg: "bg-gray-200 dark:bg-gray-800",
        // text: "text-gray-600 dark:text-gray-300",
        // dot: "bg-gray-600",
        bg: "bg-yellow-50 dark:bg-yellow-600/10",
        text: "text-yellow-600 dark:text-yellow-100",
        dot: "bg-yellow-600",
        border: "border-2 border-yellow-200 dark:border-yellow-700",
      };
  }
};

export function calculateNightsBetweenDates(checkInDate, checkOutDate) {
  const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
  const startDate = new Date(checkInDate);
  const endDate = new Date(checkOutDate);
  const diffDays = Math.round(Math.abs((endDate - startDate) / oneDay));
  return diffDays;
}
